<app-admin-header style="width: 100%;" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [stats]="[]"></app-admin-header>
<section class="container-fluid ms-main-bg py-5 nnnnn">
    <app-skelitions [hidden]="!skelition" [value]="2"></app-skelitions>
    <div class="container ms-pg-structure" *ngIf="!skelition && project">
        <app-project-details-card *ngIf="basicChannels && project && !skelition" [project]="project"
            [channels]="basicChannels" [branches]="selectedBranches"></app-project-details-card>
        <p-messages [(value)]="messages" [enableService]="false"></p-messages>

        <div class="white-box overflow-x-auto">

            <h4 class="medium-h my-4 mx-2">{{'Factors List' | translator}}</h4>
            <div class="grey-box max-width-content">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">{{'Factor' | translator}}</th>
                            <th scope="col">{{'Percentage' | translator}}</th>
                            <th scope="col">{{'Channel'| translator}}</th>
                            <th scope="col">{{'Branch' | translator}}</th>
                            <th scope="col">{{'Mystery Shopper Comment' | translator}}</th>
                            <th scope="col">{{'Approval Status' | translator}}</th>
                            <th scope="col">{{'Redo Comments' | translator}}</th>
                            <th *ngIf="isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" scope="col">{{'Repeat' | translator}}</th>
                            <th *ngIf="!isJunior && !(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))" scope="col">{{'Forward' | translator}}</th>
                            <th *ngIf="isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" scope="col">{{'Responsible' | translator}}</th>
                            <th *ngIf="isJunior || isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" scope="col">{{'Status' | translator}}</th>
                            <th *ngIf="isJunior || isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" scope="col">{{'Responsible Comments' | translator}}
                            </th>
                            <th *ngIf="isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" scope="col">{{'Action'| translator}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let factor of factors;let i=index">
                            <td data-label="">
                                <span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                {{i+1}}
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </td>
                            <td data-label="Factor">
                                <span class="ms-tabel-td-mob-mr">
                                    <div [pTooltip]="factor?.factor_details?.factor" tooltipPosition="top" class="tabel-detail-box">
                                        {{factor?.factor_details?.factor.substring(0,30)}} {{factor?.factor_details?.factor.length > 30 ? "..." : null}}
                                    </div>
                                </span>
                            </td>
                            <td data-label="Percentage">
                                <span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">{{factor?.factors?.percentage}}</div>
                                </span>
                            </td>
                            <td data-label="Channel">
                                <span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">
                                        {{factor?.channel_details?.name}}
                                        {{ (factor?.channel_details?.name == 'Branches') ? ' ('+ factor?.branch_details?.name +') ' : '' }}
                                    </div>
                                </span>
                            </td>
                            <td data-label="Branch">
                                <span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">{{factor?.branch_details?.name}}</div>
                                </span>
                            </td>
                            <td data-label="Mistry Shopper comments">
                                <span class="ms-tabel-td-mob-mr">
                                    <div [pTooltip]="factor?.factors?.msComments" tooltipPosition="top" class="tabel-detail-box">
                                        {{factor?.factors?.msComments.substring(0,30)}} {{factor?.factors?.msComments.length > 30 ? "..." : null}}
                                    </div>
                                </span>
                            </td>

                            <td data-label="Approval Status">
                                <span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">{{(factor?.factorResponsible?.approvalStatus | translator) ?? ('Pending' | translator)}}</div>
                                </span>
                            </td>

                            <td data-label="Redo Comments">
                                <span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">{{factor?.factorResponsible?.approvalComments}}</div>
                                </span>
                            </td>

                            <td *ngIf="isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" data-label="Repeat">
                                <span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">{{factor?.factorResponsible?.repeat}}</div>
                                </span>
                            </td>

                            <td *ngIf="!isJunior && !(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))" data-label="Forward">
                                <span class="ms-tabel-td-mob-mr">
                                    <div>
                                        <select [disabled]="isApproved(factor)" [(ngModel)]="factor.responsible"
                                            class="ms-dropdown-pg-12-table">
                                            <option [disabled]="true" [value]="''">Responsible</option>
                                            <option *ngFor="let responsible of project?.responsibles"
                                                [value]="responsible?.user?._id">
                                                {{extractUsername(responsible?.user?.name)}}</option>
                                        </select>
                                    </div>
                                </span>
                            </td>

                            <td *ngIf="isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" data-label="Responsible">
                                <span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">
                                        {{extractUsername(getResponsible(factor?.responsible)?.user?.name)}}</div>
                                </span>
                            </td>
                            <td *ngIf="isJunior || isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" data-label="Status">
                                <span class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start">
                                    <select *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && !isApproved(factor);else textTemplate"
                                        [disabled]="isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" [(ngModel)]="factor.factor_details.status"
                                        class="ms-dropdown-pg-12-table">
                                        <option *ngFor="let status of factorStatusConstants" [value]="status.value">
                                            {{status.label | translator}}</option>
                                    </select>
                                    <ng-template #textTemplate>
                                        <span class="ms-tabel-td-mob-mr">
                                            <div class="tabel-detail-box">{{factor.factor_details.status | translator}}</div>
                                        </span>
                                    </ng-template>
                                </span>

                            </td>
                            <td *ngIf="isJunior || isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" data-label="Responsible Comments">
                                <span *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null));else textTemplate"
                                    class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start">
                                    <input [disabled]="isApproved(factor)" [(ngModel)]="factor.rsComments" type="text"
                                        class="form-control ms-input-white-pg-5"
                                        [placeholder]="'Responsible Comments' | translator">
                                </span>
                                <ng-template #textTemplate>
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box">{{factor?.rsComments}}</div>
                                    </span>
                                </ng-template>
                            </td>


                            <td *ngIf="isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)" data-label="Action">
                                <div *ngIf="!isApproved(factor);else approvedTemplate" class="d-flex">
                                    <div tooltipPosition="top" [pTooltip]="'Redo' | translator" (click)="openRedoModal(factor)"
                                        class="circle-btnn"><i class="pi pi-refresh"></i>
                                    </div>
                                    <div tooltipPosition="top" [pTooltip]="'Approve' | translator"  (click)="confirmApprove(factor)"
                                        class="circle-btnn"><i class="pi pi-check"></i>
                                    </div>
                                    <div tooltipPosition="top" [pTooltip]="'Forward' | translator" (click)="openForwardModal(factor)"
                                        class="circle-btnn"><i class="pi pi-arrow-left"></i>
                                    </div>
                                </div>
                                <ng-template #approvedTemplate>
                                    <div class="w-100 d-center">
                                        <span class="pi pi-check" style="font-size: 1.5em;color:green"></span>
                                    </div>
                                </ng-template>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

        </div>

        <div *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))" class="d-flex justify-content-center">
            <button (click)="isJunior ? updateStatus() : assignResponsible()" class="next-btn">{{'Save' | translator}}</button>
        </div>

    </div>
</section>

<p-dialog [draggable]="false" [header]="'Forward' | translator" [style]="{minWidth: '70vw'}"
    [(visible)]="showForwardModal" (onHide)="currentFactor = null">
    <ng-template pTemplate="body">
        <div class="w-100">
            <p-dropdown appendTo="body" [placeholder]="'Responsibles'|translator" [options]="project?.responsibles"
                optionValue="user._id" [(ngModel)]="currentFactor.responsible">
                <ng-template
                    pTemplate="selectedItem">{{extractUsername(getResponsible(currentFactor.responsible)?.user?.name)}}</ng-template>
                <ng-template let-item pTemplate="item">
                    {{extractUsername(item.user?.name)}}
                </ng-template>
            </p-dropdown>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button (click)="updateResponsible()" class="next-btn">{{'Save' | translator}}</button>
    </ng-template>
</p-dialog>

<p-dialog [draggable]="false" [header]="'Redo' | translator" [style]="{minWidth: '70vw'}" [(visible)]="showRedoModal"
    (onHide)="currentFactor = null">
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    <ng-template pTemplate="body">
        <span class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start">
            <textarea rows="4" [(ngModel)]="currentFactor.redoReason" type="text"
                class="form-control ms-input-textarea-v4" [placeholder]="'Comments'|translator"></textarea>
        </span>
    </ng-template>
    <ng-template pTemplate="footer">
        <button (click)="confirmRedo()" class="next-btn">{{'Submit' | translator}}</button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>
<app-footer></app-footer>